import getAxiosInstance from "../../getAxiosInstance";

type SignupPayload = {
  emailAddress: string;
  referralCode?: string;
  acquisitionSource?: string;
  acquisitionCampaign?: string;
  demoMockUserId?: string;
};

export default async function signupWithEmail({
  emailAddress,
  referralCode,
  acquisitionSource,
  acquisitionCampaign,
  demoMockUserId,
}: SignupPayload) {
  try {
    const body: SignupPayload = {
      emailAddress,
    };
    if (referralCode) {
      body.referralCode = referralCode;
    }
    if (acquisitionSource) {
      body.acquisitionSource = acquisitionSource;
    }
    if (acquisitionCampaign) {
      body.acquisitionCampaign = acquisitionCampaign;
    }
    if (demoMockUserId) {
      body.demoMockUserId = demoMockUserId;
    }
    const res = await getAxiosInstance().post("/credentials/email", body);
    return {
      ok: res.status === 204,
      ...res,
    };
  } catch (err) {
    return {
      ok: false,
      ...err.response,
    };
  }
}
